import React from "react";
import {DynamicComponent, DynamicComponentProps} from "../../core/_models";
import {Tab, Tabs} from "react-bootstrap";
import {useDynamicComponentsState} from "../../core/DynamicComponentsState";
import {drawDynamicComponent} from "../_drawDynamicComponent";

export function StaticTabsComponent({config: {children, value, id}, context}: DynamicComponentProps) {
    const {setActiveTab, getActiveTab} = useDynamicComponentsState()
    const active = getActiveTab(id) ?? value;

    return (
        <Tabs
            id={id}
            //activeKey={value}
            defaultActiveKey={active}
            onSelect={(key) => {
                setActiveTab(id, key)
            }}
        >
            {(children as DynamicComponent[]).map(
                child =>
                    <Tab
                        eventKey={child.id}
                        title={child.caption || 'Tab'}
                    >
                        <div className='pt-6'>
                            {drawDynamicComponent(child, context)}
                        </div>
                    </Tab>
            )}
        </Tabs>
    )
}